import React, { useState } from 'react'
import { Paper } from '@mui/material'
import AddAlumniForm from '../../AdminPages/form/addAlumniForm';
import FormDialog from '../../AdminPages/panel/modal';


function AlumnicCta() {

    const [open, setOpen] = useState(false);
    const [hide, setHide] = useState(true);

    const handleClickOpen =()=> setOpen(true);

    const handleClose =()=> setOpen(false);

    return (
        <div>
            <Paper elevation={3}   className='p-3 text-center'>
                    <FormDialog
                        open={open} handleClose={handleClose} handleClickOpen={handleClickOpen} title='Add Alumni'
                        form={<AddAlumniForm from='public'
                            handleClose={handleClose} handleClickOpen={handleClickOpen} step={2}
                            hide={hide} setHide={setHide} 
                        />}
                    />
                <a onClick={handleClickOpen} href='#' style={{textDecoration : 'none'}}>
                    <div>
                        <h4>Brings former students together to maintain a <br/> connection with their university and fellow graduates. </h4>
                    </div>
                    <button className='btn btn-info btn-lg text-white px-md-4'>
                        Register as Alumni
                    </button>
                </a>
            </Paper>
        </div>
    )
}

export default AlumnicCta;